import React from 'react'
import PropTypes from 'prop-types'
import Badge from '../../ui/Badge'
import { categoryBadgeVariant } from '../IssueStatuses/constants'

const HEADING_CLASS = 'tw:flex tw:items-center tw:justify-between tw:gap-2 tw:px-2 tw:py-1'
const COUNTER_CLASS = 'tw:text-xs tw:font-medium tw:text-gray-500'

const StatusCategoryHeading = ({ data }) => (
  <div className={HEADING_CLASS}>
    <Badge variant={categoryBadgeVariant(data.value)}>{data.label}</Badge>
    <span className={COUNTER_CLASS}>{data.options.length}</span>
  </div>
)

StatusCategoryHeading.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    value: PropTypes.string.isRequired
  }).isRequired
}

export default StatusCategoryHeading
